<template>
			<div class="col-12 dasboard-left-section stream_planner_view">
				<div class="course-description col-12">

          		<div class="calendar_container">

					<div class="planner_header" style="padding-top: 20px;">
        				<div class="year_dropdown">
        					Academic Year {{computedAcademicYear}}
        				</div>

        				<div class="legends">
        					<div class="lg_col">
        						<span class="lg_block schedule"></span>
        						<span class="lg_txt">scheduled</span>
        					</div>
        					<div class="lg_col">
        						<span class="lg_block conflict"></span>
        						<span class="lg_txt">conflict</span>
        					</div>
        				</div> <!-- .legends -->
        			</div> <!-- .planner_header -->

					<div class="calendar_header">
						<div class="weekday_title">{{computedAcademicYear}}</div>
						<div class="weekday">Mod 1</div>
						<div class="weekday">Mod 2</div>
						<div class="weekday">Mod 3</div>
						<div class="weekday">Mod 4</div>
						<div class="weekday">Mod 5</div>
						<div class="weekday">Mod 6</div>
					</div> <!-- .calendar_header -->

					<div class="calendar_details_section" style="height: calc(100vh - 264px);">
						<div class="term_slot_section">


							<div class="term_slot_row">

								<div class="term_slot">
									<div class="term_slot"><span>A</span></div>
								</div> <!-- .term_slot -->

								<template v-for="c in getCourses('MOD1_A')">
										<div class="course_class_time mod_1" :class="c.class">
          								<div class="course_details">
										<v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          								</div> <!-- .course_class_time -->
        								</div> <!-- .course_class_time -->
                					</template>

			                  	<template v-for="c in getCourses('MOD2_A')">
		  							<div class="course_class_time mod_2" :class="c.class">
		            					<div class="course_details">
										<v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
		            					</div> <!-- .course_class_time -->
		          					</div> <!-- .course_class_time -->
			                  	</template>

			                  	<template v-for="c in getCourses('MOD3_A')">
		  							<div class="course_class_time mod_3" :class="c.class">
		            					<div class="course_details">
										 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>

		            					</div> <!-- .course_class_time -->
		          					</div> <!-- .course_class_time -->
			                  	</template>

			                  <template v-for="c in getCourses('MOD4_A')">
			  									<div class="course_class_time mod_4" :class="c.class">
			            					<div class="course_details">

												 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
			            					</div> <!-- .course_class_time -->
			          					</div> <!-- .course_class_time -->
			                  </template>

			                  <template v-for="c in getCourses('MOD5_A')">
			  									<div class="course_class_time mod_5" :class="c.class">
			            					<div class="course_details">

												 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
			            					</div> <!-- .course_class_time -->
			          					</div> <!-- .course_class_time -->
			                  </template>

			                  <template v-for="c in getCourses('MOD6_A')">
			  									<div class="course_class_time mod_6" :class="c.class">
			            					<div class="course_details">

												 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
			            					</div> <!-- .course_class_time -->
			          					</div> <!-- .course_class_time -->
			                  </template>

							</div> <!-- .term_slot_row -->


							<!-- ########################### -->
							<!-- dummy data section data - need to remove -->
							<!-- ########################### -->

							<div class="term_slot_row">

								<div class="term_slot">
									<div class="term_slot"><span>B</span></div>
								</div> <!-- .term_slot -->

			                 	<template v-for="c in getCourses('MOD1_B')">
		  							<div class="course_class_time mod_1" :class="c.class">
		            					<div class="course_details">

											 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
		            					</div> <!-- .course_class_time -->
		          					</div> <!-- .course_class_time -->
			                  	</template>

			                  	<template v-for="c in getCourses('MOD2_B')">
		  							<div class="course_class_time mod_2" :class="c.class">
		            					<div class="course_details">

											 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
		            					</div> <!-- .course_class_time -->
		          					</div> <!-- .course_class_time -->
			                  	</template>

			                  <template v-for="c in getCourses('MOD3_B')">
			  									<div class="course_class_time mod_3" :class="c.class">
			            					<div class="course_details">
											 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>

			            					</div> <!-- .course_class_time -->
			          					</div> <!-- .course_class_time -->
			                  </template>

			                  <template v-for="c in getCourses('MOD4_B')">
			  									<div class="course_class_time mod_4" :class="c.class">
			            					<div class="course_details">
											 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>

			            					</div> <!-- .course_class_time -->
			          					</div> <!-- .course_class_time -->
			                  </template>

			                  	<template v-for="c in getCourses('MOD5_B')">
			  									<div class="course_class_time mod_5" :class="c.class">
			            					<div class="course_details">
											 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>

			            					</div> <!-- .course_class_time -->
			          					</div> <!-- .course_class_time -->
			                  	</template>

			                  	<template v-for="c in getCourses('MOD6_B')">
	  								<div class="course_class_time mod_6" :class="c.class">
	            						<div class="course_details">
										 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>

	            						</div> <!-- .course_class_time -->
	          						</div> <!-- .course_class_time -->
			                  	</template>


							</div> <!-- .term_slot_row -->


							<div class="term_slot_row">

								<div class="term_slot">
									<div class="term_slot"><span>C</span></div>
								</div> <!-- .term_slot -->
                <template v-for="c in getCourses('MOD1_C')">
									<div class="course_class_time mod_1" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD2_C')">
									<div class="course_class_time mod_2" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD3_C')">
									<div class="course_class_time mod_3" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD4_C')">
									<div class="course_class_time mod_4" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD5_C')">
									<div class="course_class_time mod_5" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD6_C')">
									<div class="course_class_time mod_6" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>


							</div> <!-- .term_slot_row -->


							<div class="term_slot_row">

								<div class="term_slot">
									<div class="term_slot"><span>D</span></div>
								</div> <!-- .term_slot -->
                <template v-for="c in getCourses('MOD1_D')">
									<div class="course_class_time mod_1" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD2_D')">
									<div class="course_class_time mod_2" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD3_D')">
									<div class="course_class_time mod_3" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD4_D')">
									<div class="course_class_time mod_4" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD5_D')">
									<div class="course_class_time mod_5" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD6_D')">
									<div class="course_class_time mod_6" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>

							</div> <!-- .term_slot_row -->

              <div class="term_slot_row">

								<div class="term_slot">
									<div class="term_slot"><span>D-MR</span></div>
								</div> <!-- .term_slot -->
                <template v-for="c in getCourses('MOD1_D-MR')">
									<div class="course_class_time mod_1" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD2_D-MR')">
									<div class="course_class_time mod_2" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD3_D-MR')">
									<div class="course_class_time mod_3" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD4_D-MR')">
									<div class="course_class_time mod_4" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD5_D-MR')">
									<div class="course_class_time mod_5" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD6_D-MR')">
									<div class="course_class_time mod_6" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>

							</div> <!-- .term_slot_row -->

              <div class="term_slot_row">

								<div class="term_slot">
									<div class="term_slot"><span>D-TF</span></div>
								</div> <!-- .term_slot -->
                <template v-for="c in getCourses('MOD1_D-TF')">
									<div class="course_class_time mod_1" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD2_D-TF')">
									<div class="course_class_time mod_2" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD3_D-TF')">
									<div class="course_class_time mod_3" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD4_D-TF')">
									<div class="course_class_time mod_4" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD5_D-TF')">
									<div class="course_class_time mod_5" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD6_D-TF')">
									<div class="course_class_time mod_6" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>

							</div> <!-- .term_slot_row -->

              <div class="term_slot_row">

								<div class="term_slot">
									<div class="term_slot"><span>D-TWF</span></div>
								</div> <!-- .term_slot -->
                <template v-for="c in getCourses('MOD1_D-TWF')">
									<div class="course_class_time mod_1" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD2_D-TWF')">
									<div class="course_class_time mod_2" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD3_D-TWF')">
									<div class="course_class_time mod_3" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD4_D-TWF')">
									<div class="course_class_time mod_4" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD5_D-TWF')">
									<div class="course_class_time mod_5" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>
                <template v-for="c in getCourses('MOD6_D-TWF')">
									<div class="course_class_time mod_6" :class="c.class">
          					<div class="course_details">
            						 <v-clamp class="title_new" autoresize :max-lines="3" v-b-popover.hover="c.title" placement="auto">{{c.title}}</v-clamp>
          					</div> <!-- .course_class_time -->
        					</div> <!-- .course_class_time -->
                </template>

							</div> <!-- .term_slot_row -->

						</div> <!-- .term_slot_section -->
  					</div> <!-- .calendar_details_section -->
				</div>


				</div>
			</div>
</template>

<script>
import '../../../assets/module/css/stream/streamPlanner.min.css'
import { mapState, mapActions } from 'vuex'
import VClamp from 'vue-clamp'

export default {
  name: 'streamPlanner',
  props: ['uuid', 'academicYear'],
  components: {
    VClamp
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole'),
      academicYearDefault: '2020-2021'
    }
  },

  mounted () {
    this.loadStream()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadStreamDetail',
      'loadLogDashboardActivity',
      'loadStreamPlannerView'
    ]),

    loadStream () {
      this.loadStreamPlannerView(this.uuid)
    },

    getCourses (term) {
      var courses = this.planner[this.computedAcademicYear + '_' + term]
      var parsedCourses = []
      if (courses) {
        for (var i = 0; i < courses.length; i++) {
          var c = courses[i]
          if (courses.length > 1) {
            c.class = this.conflictClass(courses.length) + ' conflict_n' + (i + 1)
          } else {
            c.class = 'no-conflict'
          }
          parsedCourses.push(c)
        }
      }
      return parsedCourses
    },
    conflictClass (len) {
      if (len === 2) {
        return 'conflict two_conflicts'
      } else if (len >= 3) {
        return 'conflict three_conflicts'
      } else {
        return ''
      }
    }
  },

  computed: {
    ...mapState({
      'stream': state => state.stream.stream,
      'terms': state => state.stream.terms,
      'blocks': state => state.stream.blocks,
      'academicYears': state => state.stream.academicYears,
      'planner': state => state.stream.planner
    }),
    advisorTitle () {
      if (this.userrole === 'Advisor') {
        return '' + this.stream.ownerName + ''
      } else {
        return ''
      }
    },
    computedAcademicYear () {
      if (!this.academicYear) {
        return this.academicYearDefault
      }
      return this.academicYear
    }
  },

  watch: {
  }
}
</script>
<style>
.jumbotron {
  background: #fffff;
}
.text-center {
  text-align: center;
}
.bg-gray{
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/app/stream/components/Planner.vue